import SocialProofSaving from 'components/SocialProofs/SocialProofSaving'
import React, { Component } from 'react'
import './MobileHeader.less'

export class MobileHeader extends Component {
    render() {
        return (
            <div className="mobile-header">
                <div className="main-heading">
                    {this.props.heading}
                </div>
                {window.innerWidth >= 1024 ? <div className="social-proof-saving-header">
                    <SocialProofSaving saving={350} />
                </div> : ''}
                {this.props.subheading &&
                    <div className="sub-heading">
                        “{this.props.subheading}”
                </div>
                }
            </div>
        )
    }
}

export default MobileHeader
